import React from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ArrowLeft } from "assets/vectors";
import { BigCta } from "components/big-cta";
import { Button } from "components/button";
import { Footer } from "components/footer";
import { NavBar } from "components/navbar";
import { Integrations } from "containers/integrations";
import { MainContainer } from "containers/main-container";
import { Offerings, OtherOfferings } from "containers/offerings";
import { ProductFeatures } from "containers/product-features";
import { Services } from "containers/services";
import useHelper from "helpers";
import { Meta } from "seo";
import { Banner2 } from "styles/banners";
import { TextHeadingOne, ParagraphText } from "styles/typography";

export default function Setup() {
   const { handleCta } = useHelper();
   const { t } = useTranslation("common");
   return (
      <>
     
      <Meta title={t("feature-seo-title")} description={t("feature-seo-description")}>
         
         <MainContainer>
            <NavBar />
       
            <Banner2>
               <TextHeadingOne mw="1000" center>
                  {t("feature-title")}
               </TextHeadingOne>
               <ParagraphText mw="595" center>
                  {t("feature-description")}
               </ParagraphText>

            <Button
                  variant="primary"
                  size="regular"
                  width="200"
                  onClick={handleCta}
                  style={{ marginTop: "3em", cursor: "pointer !important", zIndex: 10 }}
               >
                  {t("try-cta-text")} <ArrowLeft />
               </Button>
            </Banner2>
             
            <ProductFeatures />
            <Offerings />
            <OtherOfferings />
            <Services />
            <Integrations /> 
            <BigCta />
         </MainContainer>
         <Footer />
      </Meta> </>
   );
}

export const getServerSideProps = async ({ locale }) => ({
   props: {
      ...(await serverSideTranslations(locale, ["common"])),
   },
});
